'use client';

import { useEffect, useRef } from 'react';

import { trackErrorCustom } from '@libs/analytics';

import { useMiniPdpDrawer } from './use-mini-pdp-drawer';

const SITE_SECTION = 'mini pdp';
const ERROR_MESSAGE = 'unexpected error';

export function useMiniPdpErrorAnalytics(hasUnexpectedError: boolean) {
    const isOpen = useMiniPdpDrawer(state => state.isOpen);
    const productId = useMiniPdpDrawer(state => state.productId);
    const lastTrackedKeyRef = useRef<string | null>(null);

    useEffect(() => {
        if (!isOpen || !hasUnexpectedError) {
            lastTrackedKeyRef.current = null;
            return;
        }

        if (!productId || lastTrackedKeyRef.current === productId) {
            return;
        }

        lastTrackedKeyRef.current = productId;
        trackErrorCustom(SITE_SECTION, ERROR_MESSAGE);
    }, [hasUnexpectedError, isOpen, productId]);
}
